<template>
  <div class="profile-container smooth-scroll">
    <!-- Hero Section with Background -->
    <div class="hero-section">
      <div class="hero-background">
        <div class="hero-gradient"></div>
      </div>
      <!-- FLEX ROW: Profile Card | Content Section -->
      <div class="profile-main-row">
        <!-- Profile Card (Left) -->
        <div class="profile-card connected-card profile-half organized-card">
          <div class="flex-card">
          <!-- Profile Header Row: Avatar | Details | Verification -->
          <div class="profile-header-row organized-header-row">
            <!-- Avatar -->
            <div class="avatar-container">
              <div class="avatar-wrapper connected-avatar-wrapper">
                <div class="profile-avatar connected-avatar">
                  <img v-if="displayAvatar" :src="displayAvatar" alt="Profile Avatar" @error="avatarError = true">
                  <div v-if="!displayAvatar || avatarError" class="default-avatar">
                    <svg viewBox="0 0 24 24" fill="currentColor" class="avatar-icon">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                    </svg>
                  </div>
                </div>
                <div class="avatar-status">
                  <div class="status-dot"></div>
                </div>
              </div>
              <button class="avatar-edit-btn" @click="editProfile">
                <i class="el-icon-camera"></i>
              </button>
            </div>
            <!-- Profile Details and Verification -->
            <div style="flex:1;">
              <div class="profile-details" style="margin-bottom: 8px;">
                <h1 class="profile-name" style="margin-bottom: 2px;">{{ name || 'User Name' }}</h1>
                <div class="profile-verifications" style="display: flex; gap: 10px; align-items: center; margin-bottom: 6px;">
                  <span class="verification-badge" style="display: flex; align-items: center; gap: 4px; background: #e6f7f2; color: #10b981; border-radius: 8px; padding: 2px 10px; font-size: 0.95rem; font-weight: 600;">
                    <i class="el-icon-success"></i> {{ $t('pages.userProfile.id_verified_3e759b1') }}
                  </span>
                  <span class="verification-badge" style="display: flex; align-items: center; gap: 4px; background: #e3f2fd; color: #3bc2ff; border-radius: 8px; padding: 2px 10px; font-size: 0.95rem; font-weight: 600;">
                    <i class="el-icon-message"></i> {{ $t('pages.userProfile.email_verified_9d240e9') }}
                  </span>
                </div>
                <div class="profile-badge">
                  <i class="el-icon-school"></i>
                  <span>{{ displaySchool }}</span>
                </div>
                <div class="profile-location" style="margin: 6px 0 0 0; color: #6b7280; font-size: 1.01rem; display: flex; align-items: center; gap: 6px;">
                  <i class="el-icon-location"></i>
                  <span>{{ displaySchool }}</span>
                </div>
                <p class="profile-email">{{ email || 'user@example.com' }}</p>
              </div>
              <!-- Housing Preferences Section -->
              <!-- <div class="housing-preferences-section" style="margin-top: 18px; margin-bottom: 8px;">
                <h3 style="font-size: 1.13rem; font-weight: 700; color: #1f2937; margin-bottom: 6px;">{{ $t('pages.userProfile.housing_preferences_45c40e9') }}</h3>
                <div style="display: flex; flex-wrap: wrap; gap: 24px;">
                  <div>
                    <div style="font-size: 0.98rem; color: #6b7280;">{{ $t('pages.userProfile.budget_7aeba4c') }}</div>
                    <div style="font-weight: 600; color: #222;">$800 - $800 /mo</div>
                  </div>
                  <div>
                    <div style="font-size: 0.98rem; color: #6b7280;">{{ $t('pages.userProfile.near_campus_ef995c6') }}</div>
                    <div style="font-weight: 600; color: #222;">{{ $t('pages.userProfile.washer_dryer_wi_fi_cb5014d') }}</div>
                  </div>
                </div>
              </div> -->
              <!-- Bio Section -->
              <!-- <div class="bio-section" style="margin-top: 18px;">
                <h3 style="font-size: 1.13rem; font-weight: 700; color: #1f2937; margin-bottom: 6px;">{{ $t('pages.userProfile.bio_b31fc96') }}</h3>
                <div style="color: #374151; font-size: 1.01rem; line-height: 1.6;">
                  {{ bio || 'I’m a junior biology major at State University. Looking for a friendly roommate. I’m a quiet and tidy living environment.' }}
                </div>
              </div> -->
            </div>
          </div>
          <!-- Profile Actions (Edit, Logout) -->
          <div class="profile-actions">
            <!-- Restore the original Edit Profile button -->
            <button class="action-btn primary connected-btn" @click="editProfile">
              <i class="el-icon-edit"></i>
              <span>{{ $t('pages.userProfile.edit_profile_cd280a4') }}</span>
            </button>
            <button class="action-btn secondary connected-btn" @click="showLogoutDialog">
              <i class="el-icon-switch-button"></i>
              <span>{{ $t('pages.userProfile.logout_e43d612') }}</span>
            </button>
          </div>
          </div>
        </div>

        <!-- Giveaway: compressed summary + expandable single qualifying listing -->
        <div class="reward-progress-shell reward-progress-shell--hero">
          <div class="reward-progress-card reward-progress-card--featured reward-progress-card--minimal">
            <div class="reward-progress-header reward-progress-header--minimal">
              <h2 class="reward-progress-title">{{ $t('pages.userProfile.50_for_50_starbucks_review_giveawa_9329564') }}</h2>
              <span v-if="rewardProgress" class="reward-status-chip" :class="rewardStatusClass">
                {{ rewardProgress.statusLabel }}
              </span>
            </div>

            <div v-if="rewardLoading" class="reward-progress-loading">{{ $t('pages.userProfile.loading_33ce417') }}</div>

            <div v-else class="reward-progress-body reward-progress-body--minimal">
              <template v-if="rewardProgress">
                <div class="reward-summary-bar">
                  <div class="reward-summary-meter">
                    <div class="reward-summary-meter-fill" :style="{ width: rewardOverallPercent + '%' }"></div>
                  </div>
                </div>

                <ul class="reward-quick-reqs" :aria-label="$t('pages.userProfile.starbucks_review_giveaway_requirem_deb6ec8')">
                  <li
                    v-for="(row, i) in rewardQuickRequirementLines"
                    :key="'qr-' + i"
                    class="reward-quick-row"
                    :class="row.met ? 'reward-quick-row--met' : 'reward-quick-row--not-met'"
                  >
                    <span class="reward-quick-label">{{ row.label }}</span>
                    <span class="reward-quick-ratio">{{ row.current }} / {{ row.required }}</span>
                    <span class="reward-quick-flag">{{ row.met ? 'met' : 'not met' }}</span>
                  </li>
                </ul>

                <p v-if="rewardProgress.rewardClosed" class="reward-closed-text reward-closed-text--inline">
                  {{ $t('pages.userProfile.all_reward_spots_are_filled_for_th_adb6f04') }}
                </p>

                <details
                  v-if="showRewardListingExpansion"
                  class="reward-focus-details"
                >
                  <summary class="reward-focus-summary">
                    {{ $t('pages.userProfile.qualifying_listing_one_reward_007a62d') }}
                  </summary>
                  <div v-if="rewardFocusInsightRow" class="reward-focus-inner">
                    <div class="reward-focus-listing-card">
                      <div class="reward-focus-head">
                        <div>
                          <strong class="reward-focus-title">{{ rewardFocusInsightRow.listingLabel || ('Listing #' + (rewardFocusInsightRow.houseLetId != null ? rewardFocusInsightRow.houseLetId : rewardFocusInsightRow.reviewId)) }}</strong>
                          <div class="reward-focus-badges" v-if="rewardFocusInsightBadges.length">
                            <span
                              v-for="(bd, bi) in rewardFocusInsightBadges"
                              :key="'bd-' + bi"
                              class="reward-focus-badge"
                            >{{ bd }}</span>
                          </div>
                        </div>
                        <button
                          v-if="rewardFocusInsightRow.reviewId"
                          type="button"
                          class="reward-focus-edit"
                          @click.prevent="goEditFocusReview"
                        >
                          {{ $t('pages.userProfile.open_review_b085791') }}
                        </button>
                      </div>
                      <dl class="reward-focus-dl">
                        <div class="reward-focus-dl-row">
                          <dt>{{ $t('pages.userProfile.photos_c8b2e86') }}</dt>
                          <dd>{{ rewardFocusInsightRow.photoCount }} / {{ rewardFocusPhotosRequired }}</dd>
                        </div>
                        <div class="reward-focus-dl-row">
                          <dt>{{ $t('pages.userProfile.written_detail_fc01c38') }}</dt>
                          <dd>{{ rewardFocusInsightRow.writtenReviewMet ? 'Met' : 'Needs work' }}</dd>
                        </div>
                      </dl>
                      <ul
                        v-if="rewardFocusInsightRow.perReviewNextSteps && rewardFocusInsightRow.perReviewNextSteps.length"
                        class="reward-focus-step-list"
                      >
                        <li
                          v-for="(step, si) in rewardFocusInsightRow.perReviewNextSteps.slice(0, 4)"
                          :key="'st-' + si"
                        >
                          {{ step }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </details>
              </template>

              <p v-else-if="rewardLoadError" class="reward-progress-loading">
                Couldn’t load reward status. Try refreshing.
              </p>
              <p v-else class="reward-minimal-fallback">
                Submit a housing review with photos and comments on other listings to be eligible.
              </p>

              <div v-if="showRewardCtaRow" class="reward-cta-row reward-cta-row--minimal">
                <button type="button" class="reward-cta-btn reward-cta-btn--primary" @click="goContinueReview">
                  {{ rewardPrimaryCtaLabel }}
                </button>
                <button type="button" class="reward-cta-btn reward-cta-btn--secondary" @click="goBrowseListings">
                  Browse listings
                </button>
              </div>

              <p v-if="rewardProgress && rewardProgress.adminNote" class="reward-note-text reward-note-text--minimal">
                {{ rewardProgress.adminNote }}
              </p>

              <button
                v-if="isAdmin && rewardProgress"
                type="button"
                class="reward-admin-btn"
                @click="goToRewardAdmin"
              >
                Open admin
              </button>
            </div>
          </div>
        </div>

        <div>
                                  <transition name="glide-stats" mode="out-in">
                          <div class="stats-overview connected-stats stats-inline" >
                            <div class="stats-grid stats-row">
                              <div class="stat-card connected-stat-card">
                                <div class="stat-icon reviews">
                                  <i class="el-icon-document"></i>
                                </div>
                                <div class="stat-content">
                                  <h3 class="stat-number">{{ profileReviewsWrittenCount }}</h3>
                                  <p class="stat-label">Reviews Written</p>
                                </div>
                              </div>
                              <div class="stat-card connected-stat-card">
                                <div class="stat-icon nests">
                                  <i class="el-icon-house"></i>
                                </div>
                                <div class="stat-content">
                                  <h3 class="stat-number">{{ info1.nestsNum || 0 }}</h3>
                                  <p class="stat-label">Nests Explored</p>
                                </div>
                              </div>
                              <div class="stat-card connected-stat-card">
                                <div class="stat-icon likes">
                                  <i class="el-icon-star-on"></i>
                                </div>
                                <div class="stat-content">
                                  <h3 class="stat-number">{{ info1.likesNum || 0 }}</h3>
                                  <p class="stat-label">Likes Received</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </transition>
        </div>
        <!-- Content Section (Right) -->
        <div class="content-section profile-half organized-card">
          <div class="right-content-flex">
            <div class="reviews-nests-col">
              <div class="reviews-section">
                <div class="tabs-container connected-tabs">
                  <div class="tabs-header sticky-tabs">
                    <button 
                      @click="pst('reviews')" 
                      :class="['tab-button', { active: activeTab === 'reviews' }, 'connected-tab-btn']"
                    >
                      <i class="el-icon-document"></i>
                      <span>My Reviews</span>
                      <span class="tab-count">{{ reviewsTabCount }}</span>
                      <span class="tab-underline" v-if="activeTab === 'reviews'"></span>
                    </button>
                    <button 
                      @click="pst('likedNests')" 
                      :class="['tab-button', { active: activeTab === 'likedNests' }, 'connected-tab-btn']"
                    >
                      <i class="el-icon-star-on"></i>
                      <span>Liked Nests</span>
                      <span class="tab-count">{{ nestsTabCount }}</span>
                      <span class="tab-underline" v-if="activeTab === 'likedNests'"></span>
                    </button>
                    <!-- Add more liked options here if needed -->
                  </div>
                  <transition name="fade-slide-tabs" mode="out-in">
                    <div class="tab-content" :key="activeTab">
                      <!-- Reviews Tab -->
                      <div v-if="activeTab === 'reviews'" class="content-panel">
                        <div class="panel-header">
                          <h2>My Reviews</h2>
                          <p class="panel-subtitle">Your honest feedback on student housing</p>
                        </div>
                        <div class="my-review-search-bar">
                          <svg class="my-review-search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="11" cy="11" r="8"/>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                          </svg>
                          <input
                            v-model="myReviewSearchQuery"
                            type="text"
                            class="my-review-search-input"
                            placeholder="Search your reviews by name, address, area..."
                          />
                          <button v-if="myReviewSearchQuery" class="my-review-search-clear" @click="myReviewSearchQuery = ''">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2.5" stroke-linecap="round">
                              <line x1="18" y1="6" x2="6" y2="18"/>
                              <line x1="6" y1="6" x2="18" y2="18"/>
                            </svg>
                          </button>
                        </div>
                        <div class="my-review-sort-filters">
                          <button type="button" :class="['my-sort-pill', { active: myReviewSortBy === 'latest' }]" @click.stop.prevent="setMyReviewSort('latest')">🕐 Latest</button>
                          <button type="button" :class="['my-sort-pill', { active: myReviewSortBy === 'earliest' }]" @click.stop.prevent="setMyReviewSort('earliest')">📅 Earliest</button>
                          <button type="button" :class="['my-sort-pill', { active: myReviewSortBy === 'rating-high' }]" @click.stop.prevent="setMyReviewSort('rating-high')">⭐ Highest Rated</button>
                          <button type="button" :class="['my-sort-pill', { active: myReviewSortBy === 'rating-low' }]" @click.stop.prevent="setMyReviewSort('rating-low')">⭐ Lowest Rated</button>
                          <button type="button" :class="['my-sort-pill', { active: myReviewSortBy === 'price-high' }]" @click.stop.prevent="setMyReviewSort('price-high')">💰 Price High→Low</button>
                          <button type="button" :class="['my-sort-pill', { active: myReviewSortBy === 'price-low' }]" @click.stop.prevent="setMyReviewSort('price-low')">💰 Price Low→High</button>
                        </div>
                        <p v-if="myReviewSearchQuery && filteredMyReviews.length === 0" class="no-my-review-results">
                          No reviews found matching "<strong>{{ myReviewSearchQuery }}</strong>"
                        </p>
                        <div class="items-grid">
                          <div
                            v-for="(item, index) in filteredMyReviews"
                            :key="item.id != null ? `review-${item.id}` : `review-${index}`"
                            class="item-card connected-item-card"
                            @click="goToMyReview(item)"
                          >
                            <div class="item-header item-header--review">
                              <div class="item-title-stack">
                                <h3 class="item-title">{{ myReviewCardTitle(item) }}</h3>
                                <span v-if="profileReviewIsDraft(item)" class="my-review-draft-pill">Draft</span>
                              </div>
                              <div class="rating-display">
                                <span v-if="profileReviewIsDraft(item)" class="rating-score rating-score-draft">In progress</span>
                                <span v-else class="rating-score">{{ formatProfileAverage(item) }}/5</span>
                              </div>
                            </div>
                            <div class="item-details">
                              <div class="detail-row">
                                <i class="el-icon-location"></i>
                                <span>{{ item.address }}</span>
                              </div>
                              <div class="detail-row">
                                <i class="el-icon-office-building"></i>
                                <span>{{ item.area }}</span>
                              </div>
                            </div>
                            <div class="item-footer">
                              <span class="review-date">{{ formatProfileReviewDate(item) }}</span>
                              <i class="el-icon-arrow-right"></i>
                            </div>
                          </div>
                        </div>
                        <!-- <transition name="glide-stats" mode="out-in">
                          <div class="stats-overview connected-stats stats-inline" v-if="activeTab === 'reviews'">
                            <div class="stats-grid stats-row">
                              <div class="stat-card connected-stat-card">
                                <div class="stat-icon reviews">
                                  <i class="el-icon-document"></i>
                                </div>
                                <div class="stat-content">
                                  <h3 class="stat-number">{{ profileReviewsWrittenCount }}</h3>
                                  <p class="stat-label">Reviews Written</p>
                                </div>
                              </div>
                              <div class="stat-card connected-stat-card">
                                <div class="stat-icon nests">
                                  <i class="el-icon-house"></i>
                                </div>
                                <div class="stat-content">
                                  <h3 class="stat-number">{{ info1.nestsNum || 0 }}</h3>
                                  <p class="stat-label">Nests Explored</p>
                                </div>
                              </div>
                              <div class="stat-card connected-stat-card">
                                <div class="stat-icon likes">
                                  <i class="el-icon-star-on"></i>
                                </div>
                                <div class="stat-content">
                                  <h3 class="stat-number">{{ info1.likesNum || 0 }}</h3>
                                  <p class="stat-label">Likes Received</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </transition> -->
                      </div>
                      <!-- Liked Nests Tab -->
                      <div v-if="activeTab === 'likedNests'" class="content-panel">
                        <div class="panel-header">
                          <h2>Liked Nests</h2>
                          <p class="panel-subtitle">Housing options you've saved</p>
                        </div>
                        <div class="items-grid liked-nests-grid">
                          <div
                            v-for="(item, index) in likedNests"
                            :key="index"
                            class="item-card liked connected-item-card"
                            @click="goToHouseDetail(item.houseId, item.houseLetId)"
                          >
                            <div class="item-header">
                              <h3 class="item-title">{{ item.name }}</h3>
                              <div class="like-badge">
                                <i class="el-icon-star-on"></i>
                                <span>Liked</span>
                              </div>
                            </div>
                            <div class="item-details">
                              <div class="detail-row">
                                <i class="el-icon-location"></i>
                                <span>{{ item.address }}</span>
                              </div>
                              <div class="detail-row">
                                <i class="el-icon-money"></i>
                                <span>${{ item.rentValue }}/month</span>
                              </div>
                            </div>
                            <div class="item-footer">
                              <span class="like-date">Liked recently</span>
                              <i class="el-icon-arrow-right"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Add more liked options tab panels here if needed -->
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <!-- <div class="housing-experiences-section">
              <h2>Housing Experiences</h2>
              <div class="housing-experience-card">
                <div class="experience-header">
                  <span class="experience-rating">5/5</span>
                  <span class="experience-title">Woodland Apartments</span>
                </div>
                <div class="experience-dates">August 2023 - May 2024</div>
                <div class="experience-review">
                  I lived at Woodland. It was a great place to campus, spacious, and clean. It had good management. Nice, might have some noise from neighbors.
                </div>
                <div class="experience-images">
                  <img src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80" alt="Apartment 1" />
                  <img src="https://images.unsplash.com/photo-1512918728675-ed5a9ecdebfd?auto=format&fit=crop&w=400&q=80" alt="Apartment 2" />
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div> <!-- close .profile-main-row -->
  </div> <!-- close .profile-container -->
</template>
  
  <script>
  import Swal from 'sweetalert2';
  import axios from "axios";
  import { clearStoredAuth } from '@/utils/auth';
  const { filterAndSortMyReviews } = require('../utils/reviewListFilters');
  const { buildMyReviewNavigation } = require('../utils/reviewNavigation');
  
  export default {
    mounted() {
    this.pst('reviews');
    this.preNum();
    this.loadRewardProgress();

    this.selectTab('likedNests',this);
    this.selectTab('reviews',this);
  },
    data() {
      return {
        activeTab: 'reviews',
      info: [],
      likedNests: [],
      info1: { reviewsNum: 0, nestsNum: 0, likesNum: 0 },
      myReviewSearchQuery: '',
      myReviewSortBy: 'latest',
      rewardProgress: null,
      rewardLoading: false,
      rewardLoadError: false,
      rewardInsightReviews: [],
      rewardInsightComments: null,
        name: localStorage.getItem('name') || 'User',
        email: localStorage.getItem('email') || '',
      avatar: localStorage.getItem('avatar') || '',
      avatarError: false,
        school: localStorage.getItem('school') || 'School',
        bio: localStorage.getItem('bio') || 'I’m a junior biology major at State University. Looking for a friendly roommate. I’m a quiet and tidy living environment.'
      };
    },
    computed: {
      displayAvatar() {
        if (!this.avatar || this.avatar === '/avatar/default-avatar.png' || this.avatarError) {
          return '';
        }
        const normalizedAvatar = String(this.avatar).trim();
        const legacyNamedAvatarMatch = normalizedAvatar.match(/Avatar\s+(\d+)\.png$/i);
        if (legacyNamedAvatarMatch) {
          return `/avatar/${legacyNamedAvatarMatch[1]}.png`;
        }
        if (normalizedAvatar.startsWith('http://') || normalizedAvatar.startsWith('https://')) {
          return normalizedAvatar;
        }
        if (normalizedAvatar.startsWith('/avatar/')) {
          return normalizedAvatar;
        }
        return `/avatar/${normalizedAvatar.replace(/^\/+/, '')}`;
      },
      filteredMyReviews() {
        return filterAndSortMyReviews(this.info, this.myReviewSearchQuery, this.myReviewSortBy);
      },
      isAdmin() {
        return String(localStorage.getItem('role') || '').toLowerCase() === 'admin';
      },
      displaySchool() {
        if (this.isAdmin) return 'Sparrow Squad';
        return this.school || 'University';
      },
      rewardStatusClass() {
        const status = this.rewardProgress?.status || '';
        return `reward-status-${String(status).toLowerCase()}`;
      },
      profileReviewsWrittenCount() {
        return Math.max(this.info1.reviewsNum || 0, this.info.length);
      },
      /** Aligns with hero stats once loaded; uses list length while counts are still 0 during parallel fetch. */
      reviewsTabCount() {
        return Math.max(this.info1.reviewsNum || 0, this.info.length);
      },
      nestsTabCount() {
        return this.info1.nestsNum || this.likedNests.length;
      },
      rewardOverallPercent() {
        const p = this.rewardProgress;
        if (!p) return 0;
        let done = 0;
        const total = 3;
        if (p.reviewCompleted) done += 1;
        if (p.photoCount >= p.requiredPhotoCount) done += 1;
        if (p.eligibleCommentCount >= p.requiredCommentCount) done += 1;
        return Math.round((done / total) * 100);
      },
      /** Compressed rows: Write a review, Photos on qualifying review, Comments — matches campaign totals. */
      rewardQuickRequirementLines() {
        const p = this.rewardProgress;
        if (!p) return [];
        const reqPhoto = Math.max(1, Number(p.requiredPhotoCount) || 2);
        const reqComm = Math.max(0, Number(p.requiredCommentCount) || 0);
        const photoNow = Number(p.photoCount) || 0;
        const commNow = Number(p.eligibleCommentCount) || 0;
        const reviewMet = !!p.reviewCompleted;
        const photoMet = photoNow >= reqPhoto;
        const commMet = reqComm <= 0 ? true : commNow >= reqComm;
        const rows = [
          { label: 'Write a full review', current: reviewMet ? 1 : 0, required: 1, met: reviewMet },
          { label: 'Photos on that review', current: photoNow, required: reqPhoto, met: photoMet },
        ];
        if (reqComm > 0) {
          rows.push({
            label: 'Comments made',
            current: commNow,
            required: reqComm,
            met: commMet,
          });
        }
        return rows;
      },
      rewardPrimaryCtaLabel() {
        const p = this.rewardProgress;
        if (!p) return 'Write a review';
        if (p.reviewId && (!p.reviewCompleted || p.photoCount < p.requiredPhotoCount)) {
          return 'Continue your review';
        }
        if (p.reviewId) {
          return 'Open your review';
        }
        return 'Write a review';
      },
      /** Use server insights when present; otherwise infer rows from `/info/reviews` so drafts still show giveaway hints. */
      mergedRewardInsightReviews() {
        const api = Array.isArray(this.rewardInsightReviews) ? this.rewardInsightReviews : [];
        if (api.length > 0) return api;
        return this.buildSyntheticInsightRowsFromProfile();
      },
      /**
       * The single review we surface for reward details — one reward per user; show the row that
       * best represents progress (campaign reviewId, then primary anchor, else highest photo+story score).
       */
      rewardFocusInsightRow() {
        const rows = Array.isArray(this.mergedRewardInsightReviews)
          ? this.mergedRewardInsightReviews.filter(Boolean)
          : [];
        if (!rows.length) return null;
        const p = this.rewardProgress;
        const pid = p && p.reviewId != null ? Number(p.reviewId) : null;
        if (Number.isFinite(pid)) {
          const match = rows.find((r) => Number(r.reviewId) === pid);
          if (match) return match;
        }
        const primary = rows.find((r) => r.primaryForGiveaway);
        if (primary) return primary;
        let best = rows[0];
        let bestScore = this.rewardReviewProgressScore(best);
        for (let i = 1; i < rows.length; i += 1) {
          const row = rows[i];
          const s = this.rewardReviewProgressScore(row);
          if (s > bestScore) {
            best = row;
            bestScore = s;
          } else if (s === bestScore) {
            if (row.primaryForGiveaway && !best.primaryForGiveaway) best = row;
            else if (Number(row.photoCount || 0) > Number(best.photoCount || 0)) best = row;
          }
        }
        return best;
      },
      rewardFocusPhotosRequired() {
        const row = this.rewardFocusInsightRow;
        const p = this.rewardProgress;
        const fromRow = row && row.photosRequired != null ? Number(row.photosRequired) : NaN;
        if (Number.isFinite(fromRow) && fromRow > 0) return fromRow;
        const fromCamp = p && p.requiredPhotoCount != null ? Number(p.requiredPhotoCount) : NaN;
        return Number.isFinite(fromCamp) && fromCamp > 0 ? fromCamp : 2;
      },
      /** Short badges for expanded listing row (PRIMARY / Draft). */
      rewardFocusInsightBadges() {
        const row = this.rewardFocusInsightRow;
        if (!row) return [];
        const out = [];
        if (row.primaryForGiveaway) {
          out.push('PRIMARY FOR GIVEAWAY');
          out.push('ANCHORS GIVEAWAY');
        }
        if (row.draft) out.push('DRAFT');
        return [...new Set(out)];
      },
      showRewardListingExpansion() {
        if (!this.rewardFocusInsightRow) return false;
        const st = String(this.rewardProgress?.status || '').toUpperCase();
        if (st === 'REWARD_ISSUED' || st === 'APPROVED') return false;
        return true;
      },
      showRewardCtaRow() {
        return !!this.rewardProgress || (this.mergedRewardInsightReviews && this.mergedRewardInsightReviews.length > 0);
      }
    },
    methods: {
    setMyReviewSort(val) {
      console.log('setMyReviewSort called with:', val);
      this.myReviewSortBy = val;
    },
    preNum() {
      this.Num(this);
    },
    Num(obj) {
      axios.get('/api/house/reviewsNumAndLikeNestsNum')
                    .then(function (response) {
          const d = response?.data?.data;
          obj.info1 = {
            reviewsNum: Number(d?.reviewsNum) || 0,
            nestsNum: Number(d?.nestsNum) || 0,
            likesNum: Number(d?.likesNum) || 0
          };
                    })
                    .catch(function (error) {
                        console.log(error);
                        obj.info1 = { reviewsNum: 0, nestsNum: 0, likesNum: 0 };
                    });
    },
    loadRewardProgress() {
      this.rewardLoading = true;
      this.rewardLoadError = false;
      axios
        .get('/api/reward/me/insights')
        .then((response) => {
          const ins = response?.data?.data;
          if (ins && typeof ins === 'object' && Array.isArray(ins.reviews)) {
            this.rewardProgress = ins.campaign ?? null;
            this.rewardInsightReviews = ins.reviews || [];
            this.rewardInsightComments = ins.giveawayComments ?? null;
            return;
          }
          return axios.get('/api/reward/me').then((r2) => {
            this.rewardProgress = r2?.data?.data ?? null;
            this.rewardInsightReviews = [];
            this.rewardInsightComments = null;
          });
        })
        .catch(() =>
          axios.get('/api/reward/me').then((r2) => {
            this.rewardProgress = r2?.data?.data ?? null;
            this.rewardInsightReviews = [];
            this.rewardInsightComments = null;
          })
        )
        .catch(() => {
          this.rewardProgress = null;
          this.rewardLoadError = true;
          this.rewardInsightReviews = [];
          this.rewardInsightComments = null;
        })
        .finally(() => {
          this.rewardLoading = false;
        });
    },
    rewardReviewProgressScore(row) {
      if (!row) return -1;
      const req = Math.max(1, Number(row.photosRequired) || 2);
      const photos = Math.min(req, Number(row.photoCount) || 0);
      let score = photos / req;
      score += row.writtenReviewMet ? 1 : 0;
      if (row.primaryForGiveaway) score += 1e-3;
      return score;
    },
    goEditFocusReview() {
      const row = this.rewardFocusInsightRow;
      if (!row || row.reviewId == null) return;
      this.$router.push({ path: '/editReview', query: { id: String(row.reviewId) } });
    },
    profileReviewIsDraft(item) {
      return item && String(item.moderationStatus || '').toUpperCase() === 'DRAFT';
    },
    profileReviewPhotoCount(item) {
      if (!item || item.file == null) return 0;
      const s = String(item.file).trim();
      if (!s || s.toLowerCase() === 'null') return 0;
      return s.split(',').map((x) => x.trim()).filter(Boolean).length;
    },
    myReviewCardTitle(item) {
      if (!item) return 'Your review';
      const hn = ((item.name && String(item.name).trim()) || (item.houseName && String(item.houseName).trim()) || '');
      if (hn) return hn;
      const hid = item.houseId != null ? item.houseId : '';
      const lid = item.houseLetId != null ? item.houseLetId : '';
      if (hid !== '' && lid !== '') return `Listing (house ${hid}) · unit ${lid}`;
      if (hid !== '') return `Listing (house ${hid})`;
      return 'Your review';
    },
    formatProfileAverage(item) {
      const raw = item && item.average;
      const n = typeof raw === 'number' ? raw : parseFloat(raw);
      if (!Number.isFinite(n)) return '—';
      return String(Math.round(n * 10) / 10);
    },
    formatProfileReviewDate(item) {
      if (!item) return '';
      if (this.profileReviewIsDraft(item)) {
        return item.dateTime ? `Draft · ${this.formatShortDate(item.dateTime)}` : 'Draft';
      }
      if (item.dateTime) return this.formatShortDate(item.dateTime);
      return 'Review';
    },
    formatShortDate(dt) {
      if (!dt) return '';
      try {
        const t = Date.parse(dt);
        if (!Number.isNaN(t)) return new Date(t).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
      } catch (e) { /* ignore */ }
      return String(dt).slice(0, 10);
    },
    giveawayAnchorReviewIdFromProfile(list) {
      const rows = Array.isArray(list) ? [...list] : [];
      rows.sort((a, b) => {
        const ta = Date.parse(a && a.dateTime) || 0;
        const tb = Date.parse(b && b.dateTime) || 0;
        return tb - ta;
      });
      const pRid = this.rewardProgress && this.rewardProgress.reviewId != null ? Number(this.rewardProgress.reviewId) : null;
      if (pRid != null && rows.some((r) => r && r.id === pRid && !this.profileReviewIsDraft(r))) {
        return pRid;
      }
      const hit = rows.find((r) => r && !this.profileReviewIsDraft(r) && r.id != null);
      return hit && hit.id != null ? hit.id : null;
    },
    buildSyntheticInsightRowsFromProfile() {
      const list = Array.isArray(this.info) ? this.info : [];
      if (!list.length) return [];
      const p = this.rewardProgress;
      const reqPhoto = p && p.requiredPhotoCount != null ? Number(p.requiredPhotoCount) : 2;
      const anchorId = this.giveawayAnchorReviewIdFromProfile(list);
      return list.map((item) => {
        const id = item.id;
        const draft = this.profileReviewIsDraft(item);
        const primary = !draft && anchorId != null && id === anchorId;
        const photos = this.profileReviewPhotoCount(item);
        const written = !!(item.content && String(item.content).trim().length > 0);
        const steps = [];
        let role = 'OTHER_PUBLISHED';
        if (draft) {
          role = 'DRAFT';
          steps.push('This review is saved as a draft — it does not appear publicly or count toward giveaway totals until you publish.');
          steps.push('Open from your profile and use Publish review when ready.');
          if (!written) steps.push('Add your written narrative before publishing.');
          if (photos < reqPhoto) {
            steps.push(`Add ${Math.max(0, reqPhoto - photos)} more photo${(reqPhoto - photos) === 1 ? '' : 's'} if you want to meet the usual campaign minimum (${photos}/${reqPhoto}).`);
          }
        } else if (primary) {
          role = 'PRIMARY_GIVEAWAY';
          if (!written) steps.push('Finish the written story on this review — it anchors the checklist.');
          if (photos < reqPhoto) {
            const need = reqPhoto - photos;
            steps.push(`Add ${need} more photo${need === 1 ? '' : 's'} on this review (${photos}/${reqPhoto}).`);
          }
          if (written && photos >= reqPhoto) {
            steps.push('Photos + narrative meet the usual minimum on this anchored review.');
          }
        } else {
          role = 'OTHER_PUBLISHED';
          steps.push('Published review kept for history. Giveaway photo rules normally follow your newest published review.');
        }
        return {
          reviewId: id,
          houseId: item.houseId,
          houseLetId: item.houseLetId,
          listingLabel: this.myReviewCardTitle(item),
          moderationStatus: item.moderationStatus,
          draft,
          primaryForGiveaway: primary,
          photoCount: photos,
          photosRequired: reqPhoto,
          writtenReviewMet: written,
          giveawayRole: role,
          perReviewNextSteps: steps
        };
      });
    },
    goContinueReview() {
      let rid = this.rewardProgress && this.rewardProgress.reviewId;
      const list = Array.isArray(this.mergedRewardInsightReviews) ? this.mergedRewardInsightReviews : [];
      const primary = list.find((r) => r && r.primaryForGiveaway);
      const draft = list.find((r) => r && r.draft);
      const focus = this.rewardFocusInsightRow;
      let hasRid = rid != null && String(rid).trim() !== '';
      if (!hasRid && focus && focus.reviewId != null) {
        rid = focus.reviewId;
        hasRid = true;
      }
      if (!hasRid) {
        if (primary && primary.reviewId != null) rid = primary.reviewId;
        else if (draft && draft.reviewId != null) rid = draft.reviewId;
      }
      if (rid != null && String(rid).trim() !== '') {
        this.$router.push({ path: '/editReview', query: { id: String(rid) } });
        return;
      }
      this.$router.push('/recommendHouse');
    },
    goBrowseListings() {
      this.$router.push('/recommendHouse');
    },
    goToRewardAdmin() {
      this.$router.push('/rewardAdmin');
    },
    goToHouseDetail(houseId, houseLetId) {
      this.$router.push({ 
        path: '/HouseReviewScore', 
        query: { houseId: houseId, houseLetId: houseLetId } 
      });
    },
    goToMyReview(item) {
      this.$router.push(buildMyReviewNavigation(item));
    },
      editProfile() {
        console.log('clicked');
        if (this.$route.path !== '/userInfo') {
      this.$router.push('/userInfo');
    } else {
      console.log('Already on userInfo page');
    }
      },
    pst(tab) {
      this.selectTab(tab, this);
      },
    selectTab(tab, obj) {
        this.activeTab = tab;
      if (this.activeTab === 'likedNests') {
        axios.get('/api/info/nests')
                    .then(function (response) {
            obj.likedNests = response.data.data;
            console.log(obj.likedNests);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
      } else {
        axios.get('/api/info/reviews')
                    .then(function (response) {
            obj.info = response.data.data;
            console.log(obj.info);
                    })
                    .catch(function (error) {
                        console.log(error);
                        obj.info = [];
                    });
        }
      },
      showLogoutDialog() {
        Swal.fire({
        title: 'Ready to leave?',
        text: "You'll be logged out of your account",
        icon: 'question',
          showCancelButton: true,
        confirmButtonColor: '#3bc2ff',
        cancelButtonColor: '#64748b',
        confirmButtonText: 'Yes, logout',
        cancelButtonText: 'Stay logged in',
        customClass: {
          popup: 'swal-custom-popup',
          confirmButton: 'swal-confirm-btn',
          cancelButton: 'swal-cancel-btn'
        }
        }).then((result) => {
          if (result.isConfirmed) {
            this.logout();
          }
        });
      },
      logout() {
        clearStoredAuth();

        // Navigate to home page, then reload to reset all component state
        this.$router.push('/').then(() => {
          location.reload();
        }).catch(() => {
          // Already on home page, just reload
          location.reload();
        });
    },
    ToMain() {
        if (this.$route.path !== '/') {
      this.$router.push('/');
    } else {
      console.log('Already on MainPage');
    }
      }
    }
  };
  </script>
  
  <style scoped>
.profile-container {
  min-height: 100vh;
  background: #fafbfc;
  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  width: 100vw;
  max-width: 100vw;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.smooth-scroll {
  scroll-behavior: smooth;
}
.hero-section {
  position: relative;
  padding: 0;
  align-items: stretch;
  justify-content: center;
  overflow: visible;
  min-height: auto;
  width: 100%;
  max-width: 100%;
}
.hero-background {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  /* background: linear-gradient(135deg, #3bc2ff 0%, #764ba2 100%); */
  opacity: 0.18;
  z-index: 0;
  pointer-events: none;
}
.hero-gradient {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(120deg, rgba(0,0,0,0.08) 0%, rgba(59,194,255,0.10) 100%);
  z-index: 0;
  pointer-events: none;
}
.hero-content {
  position: relative;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.profile-card.connected-card {
  background: rgba(255,255,255,0.97);
  border-radius: 24px;
  box-shadow: 0 10px 40px rgba(59,194,255,0.10), 0 2px 8px rgba(0,0,0,0.04);
  padding: 24px 32px 32px 32px;
  max-width: 800px;
  width: calc(100% - 48px);
  margin: 0 auto;
  border: 1.5px solid #e3f2fd;
  transition: box-shadow 0.3s;
  box-sizing: border-box;
}
.profile-card.connected-card:hover {
  box-shadow: 0 18px 60px rgba(59,194,255,0.18), 0 4px 16px rgba(0,0,0,0.08);
}
.profile-header {
  display: flex;
  align-items: center;
  gap: 32px;
  justify-content: center;
}
.avatar-container {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 0 auto;
}
.flex-card{
  display: flex;
}
.avatar-wrapper.connected-avatar-wrapper {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid #e3f2fd;
  box-shadow: 0 4px 24px rgba(59,194,255,0.13);
  background: linear-gradient(135deg, #e3f2fd 0%, #f5f7fa 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.profile-avatar.connected-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.profile-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.default-avatar {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b0b8c1;
}
.avatar-icon {
  width: 60px;
  height: 60px;
}
.avatar-status {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 22px;
  height: 22px;
  background: #10b981;
  border: 2.5px solid #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.status-dot {
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
}
.avatar-edit-btn {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(50%);
  background: #e7e7e7;
  color: #3bc2ff;
  border: none;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: inset 2px 2px 5px rgba(0,0,0,0.1),
              inset -2px -2px 5px rgba(255,255,255,0.9);
  transition: background 0.2s, transform 0.2s;
  z-index: 0;
}
.avatar-edit-btn:hover {
  transform: translateX(-50%) translateY(50%) scale(1.08);
  color: #1da1f2;
}
.profile-details {
  display: flex;
  margin-left: 30px;
  flex-direction: column;
  gap: 10px;
}
.profile-name {
  font-size: 2.1rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
  line-height: 1.2;
  letter-spacing: 0.5px;
}
.profile-email {
  font-size: 1.08rem;
  color: #6b7280;
  margin: 0;
  font-weight: 500;
}
.profile-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #3bc2ff 0%, #1da1f2 100%);
  color: white;
  padding: 7px 16px;
  border-radius: 20px;
  font-size: 0.93rem;
  font-weight: 600;
  width: fit-content;
  box-shadow: 0 2px 8px rgba(59,194,255,0.08);
}
.profile-actions {
  display: flex;
  gap: 12px;
  margin-left: 50px;
  flex-direction: column;
  margin-top: 24px;
  z-index: 0;
}
.connected-btn {
  font-family: inherit;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(59,194,255,0.08);
  transition: background 0.2s, color 0.2s, box-shadow 0.2s, transform 0.2s;
}
.connected-btn.primary {
  background: linear-gradient(135deg, #3bc2ff 0%, #1da1f2 100%);
  color: white;
  border: none;
}

.connected-btn.primary:hover {
  background: linear-gradient(135deg, #1da1f2 0%, #3bc2ff 100%);
  color: #fff;
  transform: translateY(-2px) scale(1.04);
  box-shadow: 0 6px 18px rgba(59,194,255,0.18);
}
.connected-btn.secondary {
  background: #fff;
  color: #3bc2ff;
  border: 2px solid #e5e7eb;
}
.connected-btn.secondary:hover {
  background: #f9fafb;
  color: #2288bb;
  border-color: #3bc2ff;
  transform: translateY(-2px) scale(1.04);
}
.connecting-line {
  width: 100vw;
  max-width: 100%;
  height: 32px;
  background: linear-gradient(90deg, #e3f2fd 0%, #f5f7fa 100%);
  margin: -16px 0 0 0;
  border-top: 1.5px solid #e3f2fd;
  border-bottom: 1.5px solid #e3f2fd;
  box-shadow: 0 2px 8px rgba(59,194,255,0.04);
}
.stats-overview.connected-stats {
  padding: 24px 0 32px 0;
  background: none;
  box-shadow: none;
  margin-top: -16px;
}
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 32px;
}
.stat-card.connected-stat-card {
  background: #fff;
  border-radius: 18px;
  padding: 32px 18px;
  display: flex;
  align-items: center;
  gap: 18px;
  box-shadow: 0 4px 24px rgba(59,194,255,0.10);
  border: 1.5px solid #e3f2fd;
  transition: box-shadow 0.2s, border-color 0.2s, transform 0.2s;
}
.stat-card.connected-stat-card:hover {
  box-shadow: 0 10px 32px rgba(59,194,255,0.16);
  border-color: #3bc2ff;
  transform: translateY(-3px) scale(1.03);
}
.stat-icon {
  width: 54px;
  height: 54px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  background: #e7e7e7;
  box-shadow: inset 3px 3px 6px rgba(0,0,0,0.12),
              inset -3px -3px 6px rgba(255,255,255,0.8);
}
.stat-icon.reviews {
  color: #3bc2ff;
}
.stat-icon.nests {
  color: #10b981;
}
.stat-icon.likes {
  color: #f59e0b;
}
.stat-content {
  flex: 1;
}
.stat-number {
  font-size: 2.1rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 4px 0;
  line-height: 1;
}
.stat-label {
  font-size: 1rem;
  color: #6b7280;
  margin: 0;
  font-weight: 500;
  letter-spacing: 0.5px;
}
.content-section {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  background: #fafbfc;
}
.tabs-container.connected-tabs {
  background: #fff;
  border-radius: 0;
  box-shadow: none;
  border: none;
  overflow: visible;
  padding: 0;
  margin-bottom: 0;
  width: 100%;
  max-width: 100%;
}
.tabs-header.sticky-tabs {
  display: flex;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  gap: 0;
  position: sticky;
  top: 0;
  box-shadow: none;
  width: 100%;
  max-width: 100%;
  z-index: 10;
}
.tab-button.connected-tab-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 22px 0;
  background: none;
  border: none;
  cursor: pointer;
  font-weight: 700;
  color: #6b7280;
  font-size: 1.08rem;
  transition: all 0.2s cubic-bezier(.4,2,.6,1);
  position: relative;
  outline: none;
  border-bottom: 2.5px solid transparent;
  background-clip: padding-box;
}
.tab-button.connected-tab-btn.active {
  background: #fff;
  color: #3bc2ff;
  border-bottom: none;
  box-shadow: none;
  z-index: 2;
}
.tab-button.connected-tab-btn .tab-underline {
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 60%;
  height: 3px;
  background: linear-gradient(90deg, #3bc2ff 0%, #1da1f2 100%);
  border-radius: 2px;
  transform: translateX(-50%) scaleX(0.7);
  opacity: 0.7;
  transition: all 0.3s cubic-bezier(.4,2,.6,1);
  pointer-events: none;
}
.tab-button.connected-tab-btn.active .tab-underline {
  transform: translateX(-50%) scaleX(1);
  opacity: 1;
}
.tab-button.connected-tab-btn:hover {
  background: #f3f4f6;
  color: #3bc2ff;
}
.tab-count {
  background: #e5e7eb;
  color: #6b7280;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-left: 8px;
  transition: background 0.2s, color 0.2s;
}
.tab-button.connected-tab-btn.active .tab-count {
  background: #3bc2ff;
  color: #fff;
}
.fade-slide-tabs-enter-active, .fade-slide-tabs-leave-active {
  transition: opacity 0.5s cubic-bezier(.4,2,.6,1), transform 0.5s cubic-bezier(.4,2,.6,1);
}
.fade-slide-tabs-enter, .fade-slide-tabs-leave-to {
    opacity: 0;
  transform: translateY(40px);
  }
.tab-content {
  padding: 0;
  min-height: 320px;
  width: 100%;
  max-width: 100%;
  background: #fafbfc;
  }
.content-panel {
  padding: 24px 24px 48px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  box-sizing: border-box;
}
.panel-header {
  margin-bottom: 32px;
  padding: 0;
  text-align: center;
}
.panel-header h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  letter-spacing: -0.3px;
}
.panel-subtitle {
  font-size: 0.95rem;
  color: #6b7280;
  margin: 0;
  font-weight: 400;
}
.my-review-search-bar {
  display: flex;
  align-items: center;
  background: #f1f5f9;
  border: 1.5px solid transparent;
  border-radius: 12px;
  padding: 0.55rem 1rem;
  margin-bottom: 1.5rem;
  transition: all 0.25s ease;
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}
.my-review-search-bar:focus-within {
  border-color: #3bc2ff;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(59, 194, 255, 0.15);
}
.my-review-search-icon {
  flex-shrink: 0;
  margin-right: 0.5rem;
}
.my-review-search-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.9rem;
  font-weight: 500;
  color: #1f2937;
  width: 100%;
  font-family: inherit;
}
.my-review-search-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}
.my-review-search-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e2e8f0;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  padding: 0;
  margin-left: 0.5rem;
  flex-shrink: 0;
  transition: background 0.2s;
}
.my-review-search-clear:hover {
  background: #cbd5e1;
}
.no-my-review-results {
  text-align: center;
  color: #64748b;
  font-size: 0.95rem;
  padding: 2rem 1rem;
  margin: 0 0 1rem 0;
}
.my-review-sort-filters {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 2;
}
.my-sort-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.4rem 0.9rem;
  font-size: 0.8rem;
  font-weight: 600;
  font-family: inherit;
  color: #475569;
  background: #f1f5f9;
  border: 1.5px solid transparent;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  position: relative;
  z-index: 2;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.my-sort-pill:hover {
  background: #e2e8f0;
  color: #1e293b;
}
.my-sort-pill.active {
  background: #ebfaff;
  color: #0891b2;
  border-color: #3bc2ff;
  box-shadow: 0 0 0 2px rgba(59, 194, 255, 0.12);
}
.items-grid {
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  width: 100%;
  box-sizing: border-box;
  padding: 0;
}
.item-card.connected-item-card {
  background: #ffffff;
  border: none;
  border-radius: 16px;
  padding: 20px 18px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
  box-sizing: border-box;
  width: 100%;
}
.item-card.connected-item-card:hover {
  box-shadow: 0 8px 24px rgba(59, 194, 255, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1);
  background: #ffffff;
  transform: translateY(-4px);
}
.item-card.liked {
  border-left: 4px solid #f59e0b;
}
.item-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  width: 100%;
  box-sizing: border-box;
}
.item-header--review {
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px 12px;
}
.item-title-stack {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
}
.item-title-stack .item-title {
  margin: 0;
  padding-right: 0;
}
.my-review-draft-pill {
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 4px 10px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0369a1;
  border: 1px solid #bae6fd;
  flex-shrink: 0;
}
.rating-score-draft {
  font-size: 0.75rem;
  color: #64748b;
  background: #f1f5f9;
  border-color: #e2e8f0;
}
.reward-campaign-fallback {
  margin-bottom: 12px;
}
.reward-fallback-per-review-hint {
  margin: 0;
  font-size: 0.9rem;
  color: #475569;
  line-height: 1.5;
}
.item-title {
  font-size: 1.18rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
  line-height: 1.3;
  flex: 1;
  min-width: 0;
  padding-right: 12px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.rating-display {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  min-width: 70px;
}
.stars {
  display: flex;
  gap: 2px;
}
.star {
  font-size: 16px;
  transition: color 0.3s ease;
}
.star.empty {
  color: #d1d5db;
}
.star.filled {
  color: #f59e0b;
}
.rating-score {
  font-weight: 700;
  color: #3bc2ff;
  font-size: 0.85rem;
  background: rgba(59, 194, 255, 0.12);
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid rgba(59, 194, 255, 0.2);
  white-space: nowrap;
  display: inline-block;
}
.like-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  padding: 6px 14px;
  border-radius: 14px;
  font-size: 0.85rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.25);
}
.like-badge i {
  font-size: 1rem;
}
.item-details {
  margin-bottom: 16px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.detail-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 1.01rem;
  color: #6b7280;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.detail-row span {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.detail-row:last-child {
  margin-bottom: 0;
}
.detail-row i {
  color: #3bc2ff;
  font-size: 16px;
  width: 16px;
}
.item-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}
.review-date,
.like-date {
  font-size: 0.92rem;
  color: #9ca3af;
  font-weight: 500;
}
.item-footer i {
  color: #3bc2ff;
  font-size: 18px;
  transition: transform 0.3s ease;
}
.item-card:hover .item-footer i {
  transform: translateX(4px);
}
.profile-main-row {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  margin: 0;
  box-sizing: border-box;
  align-items: stretch;
  background: none;
  border-radius: 0;
  box-shadow: none;
  min-height: auto;
  padding: 0;
  gap: 0;
  position: relative;
  z-index: 1;
}
.profile-half {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.profile-card.profile-half {
  border-right: none;
}
.organized-card {
  background: #fff;
  border-radius: 0;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
}
.container {
  max-width: none !important;
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  box-sizing: border-box;
}
.organized-header-row {
  display: flex;
  align-items: flex-start;
  gap: 28px;
  margin-bottom: 18px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
}
.profile-details > * {
  margin-bottom: 10px;
}
.profile-details > *:last-child {
  margin-bottom: 0;
}
.right-content-flex {
  display: flex;
  flex-direction: row;
  gap: 0;
  align-items: flex-start;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0;
}
.reviews-nests-col {
  flex: 2 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  max-width: 100%;
}
.liked-nests-section {
  width: 60%;
  margin: 0 auto 0 0;
}
.liked-nests-grid {
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
}
.housing-experiences-section {
  flex: 1 1 0;
  min-width: 220px;
  max-width: 340px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(59,194,255,0.08);
  padding: 24px 18px 18px 18px;
  margin-left: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
}
.housing-experience-card {
  width: 100%;
}
.experience-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}
.experience-rating {
  font-weight: 700;
  color: #3bc2ff;
  font-size: 1.3rem;
  background: rgba(59, 194, 255, 0.1);
  padding: 4px 12px;
  border-radius: 8px;
  border: 1px solid rgba(59, 194, 255, 0.2);
}
.experience-title {
  font-weight: 700;
  font-size: 1.1rem;
}
.experience-dates {
  color: #6b7280;
  font-size: 0.98rem;
  margin-bottom: 8px;
}
.experience-review {
  color: #374151;
  font-size: 1.01rem;
  margin-bottom: 10px;
}
.experience-images {
  display: flex;
  gap: 10px;
}
.experience-images img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
}
/* Removed - iPads should use desktop styles */
/* Removed - iPads should use desktop styles */
.stats-inline {
  margin-top: 32px;
  width: 100%;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}
.stats-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
}
.reward-progress-shell {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 0 24px 24px;
  box-sizing: border-box;
}
.reward-progress-shell--hero {
  margin-top: 8px;
  padding-top: 16px;
}
.reward-progress-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}
.reward-progress-card--featured {
  border: 2px solid transparent;
  background:
    linear-gradient(#fff, #fff) padding-box,
    linear-gradient(135deg, rgba(59, 194, 255, 0.45), rgba(14, 165, 233, 0.2), rgba(99, 102, 241, 0.35)) border-box;
  box-shadow:
    0 12px 40px rgba(15, 23, 42, 0.08),
    0 2px 12px rgba(59, 194, 255, 0.12);
}
.reward-progress-card--minimal {
  padding: 18px 20px;
}
.reward-progress-header--minimal {
  align-items: center;
  margin-bottom: 8px;
}
.reward-progress-body--minimal {
  padding-top: 0;
}
.reward-closed-text--inline {
  margin: 10px 0 0;
  font-size: 0.87rem;
  font-weight: 600;
  color: #64748b;
}
.reward-minimal-fallback {
  margin: 4px 0 0;
  font-size: 0.92rem;
  color: #64748b;
  line-height: 1.45;
}
.reward-cta-row--minimal {
  margin-top: 14px;
}
.reward-note-text--minimal {
  margin-top: 12px;
  font-size: 0.88rem;
  color: #475569;
}
.reward-focus-details {
  margin-top: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 0;
  background: #fafbfc;
}
.reward-focus-summary {
  cursor: pointer;
  list-style: none;
  font-size: 0.88rem;
  font-weight: 600;
  color: #475569;
  padding: 12px 14px;
  user-select: none;
}
.reward-focus-summary::-webkit-details-marker {
  display: none;
}
.reward-focus-summary::before {
  content: '▸';
  display: inline-block;
  margin-right: 8px;
  transition: transform 0.15s ease;
  color: #64748b;
}
.reward-focus-details[open] .reward-focus-summary::before {
  transform: rotate(90deg);
}
.reward-focus-inner {
  padding: 0 14px 14px;
}
.reward-focus-listing-card {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 14px 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 65%);
}
.reward-focus-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}
.reward-focus-badge {
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 4px 8px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0369a1;
}
.reward-focus-step-list {
  margin: 10px 0 0;
  padding-left: 1.1rem;
  font-size: 0.84rem;
  color: #475569;
  line-height: 1.45;
}
.reward-focus-step-list li + li {
  margin-top: 4px;
}
.reward-quick-reqs {
  list-style: none;
  margin: 14px 0 0;
  padding: 0;
}
.reward-quick-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  column-gap: 10px;
  row-gap: 2px;
  font-size: 0.93rem;
  padding: 8px 0;
  border-bottom: 1px solid #eef2f6;
}
.reward-quick-row:last-child {
  border-bottom: none;
}
.reward-quick-label {
  flex: 1 1 140px;
  min-width: 0;
  color: #334155;
}
.reward-quick-ratio {
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  color: #1e293b;
}
.reward-quick-flag {
  font-size: 0.85rem;
  font-weight: 600;
}
.reward-quick-row--met .reward-quick-flag {
  color: #059669;
}
.reward-quick-row--not-met .reward-quick-flag {
  color: #b45309;
}
.reward-focus-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
}
.reward-focus-title {
  font-size: 0.95rem;
  color: #0f172a;
  line-height: 1.35;
}
.reward-focus-edit {
  flex-shrink: 0;
  border: none;
  background: none;
  color: #0284c7;
  font-weight: 700;
  font-size: 0.86rem;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}
.reward-focus-edit:hover {
  color: #0369a1;
}
.reward-focus-dl {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.reward-focus-dl-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  font-size: 0.87rem;
  color: #334155;
}
.reward-focus-dl-row dt {
  margin: 0;
  color: #64748b;
  font-weight: 600;
}
.reward-focus-dl-row dd {
  margin: 0;
  font-weight: 600;
  color: #0f172a;
  text-align: right;
}
.reward-focus-hint {
  margin: 10px 0 0;
  font-size: 0.82rem;
  color: #64748b;
  line-height: 1.45;
}
.reward-summary-bar {
  margin-top: 4px;
}
.reward-summary-meter {
  height: 10px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}
.reward-summary-meter-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #38bdf8, #3bc2ff, #818cf8);
  transition: width 0.35s ease;
  min-width: 4%;
}
.reward-summary-text {
  margin: 10px 0 0;
  font-size: 0.94rem;
  color: #334155;
  line-height: 1.45;
}
.reward-stat-chip-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-top: 20px;
}
.reward-stat-chip {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 14px 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 55%);
}
.reward-stat-chip--accent {
  border-color: rgba(59, 194, 255, 0.35);
  background: linear-gradient(180deg, #f0f9ff 0%, #fff 60%);
}
.reward-stat-chip-label {
  display: block;
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin-bottom: 6px;
}
.reward-stat-chip strong {
  display: block;
  font-size: 1.35rem;
  color: #0f172a;
  line-height: 1.2;
}
.reward-stat-chip-hint {
  display: block;
  margin-top: 4px;
  font-size: 0.8rem;
  color: #64748b;
}
.reward-stat-chip-hint {
  display: block;
  margin-top: 4px;
  font-size: 0.8rem;
  color: #64748b;
}

.reward-review-breakdown {
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid #e2e8f0;
}
.reward-breakdown-heading {
  margin: 0;
  font-size: 1.02rem;
  font-weight: 700;
  color: #0f172a;
}
.reward-breakdown-sub {
  margin: 8px 0 14px;
  font-size: 0.89rem;
  color: #64748b;
  line-height: 1.45;
}
.reward-insight-review-card {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 14px 16px;
  margin-bottom: 12px;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 65%);
}
.reward-insight-review-card--primary {
  border-color: rgba(59, 194, 255, 0.45);
  box-shadow: 0 6px 20px rgba(59, 194, 255, 0.12);
}
.reward-insight-review-card--draft {
  border-style: dashed;
  opacity: 0.98;
}
.reward-insight-review-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}
.reward-insight-title {
  display: block;
  color: #0f172a;
  font-size: 1rem;
}
.reward-insight-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.reward-mini-chip {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 4px 8px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #475569;
}
.reward-mini-chip--accent {
  background: #e0f2fe;
  color: #0369a1;
}
.reward-insight-linkish {
  border: none;
  background: none;
  color: #0284c7;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}
.reward-insight-linkish:hover {
  color: #0369a1;
}
.reward-insight-metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 20px;
  margin-top: 12px;
  font-size: 0.88rem;
  color: #64748b;
}
.reward-insight-metrics strong {
  color: #0f172a;
  font-weight: 700;
}
.reward-insight-steps {
  margin: 10px 0 0;
  padding-left: 1.1rem;
  font-size: 0.87rem;
  color: #475569;
  line-height: 1.5;
}
.reward-insight-steps li + li {
  margin-top: 4px;
}
.reward-comment-guidance-block {
  margin-top: 18px;
  padding: 14px 16px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.reward-comment-count-line {
  margin: 8px 0 10px;
  font-size: 0.92rem;
  color: #334155;
}

.reward-next-steps {
  margin: 18px 0 0;
  padding-left: 1.2rem;
  color: #475569;
  font-size: 0.93rem;
  line-height: 1.55;
}
.reward-next-steps li + li {
  margin-top: 6px;
}
.reward-cta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 22px;
}
.reward-cta-btn {
  appearance: none;
  border-radius: 12px;
  font-size: 0.94rem;
  font-weight: 600;
  padding: 12px 20px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
.reward-cta-btn--primary {
  border: none;
  background: linear-gradient(135deg, #3bc2ff 0%, #0284c7 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(59, 194, 255, 0.35);
}
.reward-cta-btn--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(59, 194, 255, 0.45);
}
.reward-cta-btn--secondary {
  border: 1.5px solid #cbd5e1;
  background: #fff;
  color: #334155;
}
.reward-cta-btn--secondary:hover {
  border-color: #3bc2ff;
  color: #0369a1;
}
.reward-progress-unavailable .reward-progress-loading {
  margin-bottom: 8px;
}
.reward-progress-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
}
.reward-progress-title {
  margin: 0;
  font-size: 1.3rem;
  color: #1f2937;
}
.reward-progress-subtitle {
  margin: 6px 0 0;
  color: #6b7280;
  font-size: 0.95rem;
}
.reward-status-chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 700;
  white-space: nowrap;
}
.reward-status-not_started { background: #f3f4f6; color: #4b5563; }
.reward-status-in_progress { background: #eff6ff; color: #1d4ed8; }
.reward-status-pending_verification { background: #fff7ed; color: #c2410c; }
.reward-status-approved { background: #ecfdf5; color: #047857; }
.reward-status-rejected { background: #fef2f2; color: #b91c1c; }
.reward-status-reward_issued { background: #f5f3ff; color: #6d28d9; }
.reward-progress-loading,
.reward-flag-text,
.reward-note-text {
  margin: 14px 0 0;
  color: #6b7280;
}
.reward-meta-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 18px;
  color: #475569;
  font-size: 0.92rem;
}
.reward-closed-text {
  color: #b91c1c;
  font-weight: 700;
}
.reward-checklist {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-top: 16px;
}
.reward-check-item {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #334155;
}
.reward-check-item.done {
  border-color: #86efac;
  background: #f0fdf4;
}
.reward-check-icon {
  font-size: 0.82rem;
  font-weight: 700;
  color: #0f766e;
}
.reward-admin-btn {
  margin-top: 16px;
  border: none;
  border-radius: 12px;
  background: #111827;
  color: #fff;
  padding: 11px 16px;
  font-weight: 600;
  cursor: pointer;
}
.stat-card.connected-stat-card {
  flex: 1 1 180px;
  min-width: 160px;
  max-width: 240px;
  opacity: 0;
  transform: translateY(60px);
  animation: glide-in 0.7s cubic-bezier(.4,2,.6,1) forwards;
}
.stat-card.connected-stat-card:nth-child(1) {
  animation-delay: 0.1s;
}
.stat-card.connected-stat-card:nth-child(2) {
  animation-delay: 0.3s;
}
.stat-card.connected-stat-card:nth-child(3) {
  animation-delay: 0.5s;
}
.glide-stats-enter-active {
  transition: opacity 0.3s ease;
}
@keyframes glide-in {
  0% {
    opacity: 0;
    transform: translateY(60px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Removed - iPads should use desktop styles */

/* Additional desktop fixes for layout containment */
@media (min-width: 769px) {
  .profile-card.connected-card {
    max-width: 800px;
    width: calc(100% - 48px);
  }

  .stats-inline {
    max-width: 800px;
  }

  .stat-card.connected-stat-card {
    flex: 1 1 220px;
    min-width: 220px;
    max-width: 280px;
  }
}

/* ========================================
   MOBILE PROFESSIONAL REDESIGN (max-width: 480px)
   iPad and Desktop styles remain completely untouched
   THIS IS THE MASTER MOBILE SECTION - All mobile styles consolidated here
   Only applies to true mobile devices (phones)
   ======================================== */

@media (max-width: 480px) {
  /* ===== CONTAINER & LAYOUT ===== */
  .profile-container {
    padding: 0 !important;
    background: #f8fafc !important;
    width: 100vw !important;
    max-width: 100vw !important;
    overflow-x: hidden !important;
    box-sizing: border-box !important;
  }

  .hero-section {
    padding: 12px 0 24px !important;
    min-height: auto !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .profile-main-row {
    padding: 0 16px !important;
    gap: 20px !important;
    width: 100% !important;
    max-width: 100vw !important;
    box-sizing: border-box !important;
  }

  .profile-main-row > div {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  .profile-half {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }

  /* Special handling for content section to break out of container */
  .profile-half.content-section {
    width: 100vw !important;
    max-width: 100vw !important;
    margin-left: -16px !important;
    margin-right: -16px !important;
    padding: 0 !important;
  }

  /* ===== PROFILE CARD ===== */
  .profile-card.connected-card {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 20px 20px 18px !important;
    border-radius: 16px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  }

  .flex-card {
    flex-direction: column !important;
  }

  .organized-header-row {
    flex-direction: column !important;
    align-items: center !important;
    gap: 16px !important;
    text-align: center !important;
    width: 100% !important;
    box-sizing: border-box !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  /* ===== AVATAR ===== */
  .avatar-container {
    width: 90px !important;
    height: 90px !important;
    margin: 0 !important;
  }

  .avatar-wrapper.connected-avatar-wrapper {
    width: 90px !important;
    height: 90px !important;
    border: 3px solid #e3f2fd !important;
  }

  .avatar-edit-btn {
    width: 32px !important;
    height: 32px !important;
    font-size: 14px !important;
  }

  /* ===== PROFILE DETAILS ===== */
  .profile-details {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    box-sizing: border-box !important;
    padding: 0 !important;
    margin: 0 !important;
    margin-left: 0 !important;
  }

  .profile-name {
    font-size: 20px !important;
    text-align: center !important;
    margin-bottom: 10px !important;
  }

  .profile-verifications {
    flex-wrap: wrap !important;
    justify-content: center !important;
    gap: 6px !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    margin-bottom: 8px !important;
  }

  .verification-badge {
    font-size: 11px !important;
    padding: 5px 10px !important;
    box-sizing: border-box !important;
  }

  .profile-badge {
    justify-content: center !important;
    font-size: 12px !important;
    padding: 7px 14px !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    margin-bottom: 6px !important;
  }

  .profile-location {
    justify-content: center !important;
    font-size: 12px !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    margin-bottom: 4px !important;
  }

  .profile-email {
    font-size: 12px !important;
    text-align: center !important;
    word-break: break-all !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  /* ===== ACTION BUTTONS ===== */
  .profile-actions {
    flex-direction: column !important;
    gap: 10px !important;
    margin-top: 16px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .action-btn {
    width: 100% !important;
    max-width: 100% !important;
    justify-content: center !important;
    padding: 12px 20px !important;
    font-size: 14px !important;
    border-radius: 10px !important;
    box-sizing: border-box !important;
    margin: 0 !important;
  }

  .action-btn.primary {
    order: 1 !important;
  }

  .action-btn.secondary {
    order: 2 !important;
  }

  /* ===== STATS SECTION ===== */
  .stats-inline {
    margin-top: 16px !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    box-sizing: border-box !important;
  }

  .stats-row {
    flex-direction: column !important;
    gap: 12px !important;
    width: 100% !important;
    box-sizing: border-box !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .stat-card.connected-stat-card {
    flex: 1 1 auto !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    padding: 18px 16px !important;
    border-radius: 12px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }

  .stat-icon {
    width: 48px !important;
    height: 48px !important;
    font-size: 24px !important;
  }

  .stat-value {
    font-size: 28px !important;
    font-weight: 700 !important;
  }

  .stat-label {
    font-size: 13px !important;
  }

  /* ===== CONTENT SECTION - REVIEWS & LIKED NESTS ===== */
  .content-section {
    width: 100vw !important;
    max-width: 100vw !important;
    box-sizing: border-box !important;
    padding: 0 !important;
    margin: 0 !important;
    margin-top: 10px !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }

  .content-section * {
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  .right-content-flex {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .reviews-nests-col {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  .reviews-section {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  .organized-card {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    padding: 0 !important;
    margin: 0 !important;
    border-radius: 0 !important;
  }
  
  .organized-card * {
    box-sizing: border-box !important;
  }

  .content-section.profile-half {
    width: 100vw !important;
    max-width: 100vw !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }

  /* ===== TABS ===== */
  .tabs-section {
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .tabs-container {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  .tabs-container.connected-tabs {
    border-radius: 0 !important;
    padding: 0 0 16px 0 !important;
    box-shadow: none !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
  }

  .tabs-header.sticky-tabs {
    border-radius: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
    background: #f9fafb !important;
  }

  .tab-button.connected-tab-btn {
    padding: 18px 16px !important;
    font-size: 15px !important;
    font-weight: 600 !important;
  }

  .tab-button.connected-tab-btn i {
    font-size: 16px !important;
  }

  .tab-count {
    font-size: 13px !important;
    padding: 4px 10px !important;
    border-radius: 12px !important;
  }

  /* ===== TAB CONTENT ===== */
  .tab-content {
    padding: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    min-height: 200px !important;
    background: #ffffff !important;
  }

  .content-panel {
    padding: 24px 16px 16px 16px !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    background: #ffffff !important;
  }

  /* ===== PANEL HEADER ===== */
  .panel-header {
    margin-bottom: 24px !important;
    padding: 0 !important;
    text-align: center !important;
  }

  .panel-header h2 {
    font-size: 22px !important;
    font-weight: 700 !important;
    margin-bottom: 10px !important;
    color: #1f2937 !important;
  }

  .panel-subtitle {
    font-size: 14px !important;
    color: #6b7280 !important;
  }

  .panel-title {
    font-size: 18px !important;
  }

  /* ===== ITEMS GRID - REVIEWS & LIKED NESTS CARDS ===== */
  .items-grid {
    display: flex !important;
    flex-direction: column !important;
    gap: 16px !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .items-grid * {
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  /* ===== REVIEW/LIKED NEST CARDS ===== */
  .item-card {
    padding: 16px !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    margin: 0 !important;
    border-radius: 14px !important;
    background: rgba(249, 250, 251, 0.9) !important;
    border: 1px solid #e5e7eb !important;
  }

  .item-card.connected-item-card {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    padding: 16px !important;
    margin: 0 !important;
    overflow: hidden !important;
    margin-bottom: 0 !important;
  }

  /* ===== CARD HEADER ===== */
  .item-header {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    gap: 12px !important;
    flex-wrap: nowrap !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    margin-bottom: 14px !important;
  }

  .item-title {
    flex: 1 !important;
    min-width: 0 !important;
    max-width: calc(100% - 65px) !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    line-height: 1.3 !important;
    color: #1f2937 !important;
  }

  .rating-display {
    flex-shrink: 0 !important;
    min-width: 50px !important;
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center !important;
  }

  .rating-score {
    font-size: 13px !important;
    font-weight: 700 !important;
    padding: 6px 10px !important;
    white-space: nowrap !important;
    display: inline-block !important;
    background: rgba(59, 194, 255, 0.12) !important;
    color: #3bc2ff !important;
    border-radius: 8px !important;
    border: 1px solid rgba(59, 194, 255, 0.2) !important;
  }

  .like-badge {
    font-size: 12px !important;
    padding: 6px 12px !important;
    border-radius: 12px !important;
  }

  /* ===== CARD DETAILS ===== */
  .item-details {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    margin-bottom: 14px !important;
  }

  .detail-row {
    font-size: 14px !important;
    margin-bottom: 8px !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    color: #6b7280 !important;
  }

  .detail-row:last-child {
    margin-bottom: 0 !important;
  }

  .detail-row i {
    font-size: 15px !important;
    color: #3bc2ff !important;
    flex-shrink: 0 !important;
  }

  /* ===== CARD FOOTER ===== */
  .item-footer {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    padding-top: 14px !important;
    border-top: 1px solid #e5e7eb !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
  }

  .item-footer i {
    font-size: 18px !important;
    flex-shrink: 0 !important;
    color: #3bc2ff !important;
  }

  .review-date,
  .like-date {
    font-size: 13px !important;
    color: #9ca3af !important;
    font-weight: 500 !important;
  }
}

/* Extra small mobile devices */
@media (max-width: 480px) {
  .profile-main-row {
    padding: 0 12px;
  }

  .profile-card.connected-card {
    padding: 20px 16px;
    border-radius: 12px;
  }

  .avatar-container {
    width: 90px;
    height: 90px;
  }

  .avatar-wrapper.connected-avatar-wrapper {
    width: 90px;
    height: 90px;
  }

  .profile-name {
    font-size: 20px !important;
  }

  .verification-badge {
    font-size: 11px !important;
    padding: 5px 10px !important;
  }

  .profile-badge {
    font-size: 12px !important;
  }

  .action-btn {
    padding: 12px 20px !important;
    font-size: 14px !important;
  }

  .stat-card.connected-stat-card {
    padding: 16px 12px !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .stat-icon {
    width: 42px !important;
    height: 42px !important;
    font-size: 20px !important;
  }

  .stat-value {
    font-size: 24px !important;
  }

  .stat-label {
    font-size: 12px !important;
  }

  .item-card {
    width: 100% !important;
    max-width: 100% !important;
    padding: 14px 12px !important;
  }

  .item-card.connected-item-card {
    padding: 14px 12px !important;
  }

  .item-title {
    font-size: 15px !important;
  }

  .rating-score {
    font-size: 12px !important;
    padding: 5px 10px !important;
  }

  .detail-row {
    font-size: 12px !important;
  }

  .review-date,
  .like-date {
    font-size: 11px !important;
  }

  .item-footer i {
    font-size: 14px !important;
  }

  .organized-card {
    padding: 20px 16px !important;
  }
}
</style>